import React, { Component } from 'react';
import { buildPath } from '../utils/route_utils.js';
import { updateSEO } from '../utils/seo_utils';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AnnouncementBanner from '../components/AnnouncementBanner';
import Breadcrumb from '../components/Breadcrumb';
import '../css/JobDetailPage.css';

class JobDetailPage extends Component {
  constructor(props) {
    super(props);
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const pageId = pathParts.length >= 3 ? pathParts[2] : '';
    this.state = { lang: this.props.lang, id: pageId };
    this.update_lang = this.update_lang.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    updateSEO('career', this.state.lang, '/about/' + this.state.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) this.setState({ lang: nextProps.lang });
  }

  update_lang(newLang) { this.props.updateLang(newLang); }
  navigate(route) { window.location.href = buildPath(this.state.lang, route); }

  getPageData() {
    const pages = {
      "SE-robot": {
        title: { zh: "機器人軟體工程師", en: "Robot Software Engineer", ja: "ロボットソフトウェアエンジニア" },
        type: { zh: "全職", en: "Full-time", ja: "フルタイム" },
        location: { zh: "新竹縣竹北市", en: "Zhubei, Hsinchu County", ja: "新竹県竹北市" },
        sections: {
          zh: [
            { heading: "職務說明", items: ["開發與維護機器人軟體系統，包含感知、定位（SLAM）、路徑規劃與即時運動控制", "基於 ROS2 框架進行機器人系統架構設計與模組開發", "整合多種感測器（LiDAR、深度相機、IMU、編碼器等）並開發感測器融合演算法", "開發與調校導航、避障與路徑規劃模組", "將機器人軟體部署至邊緣運算平台（如 NVIDIA Jetson）", "與硬體及 AI 團隊協作，進行系統整合與現場測試"] },
            { heading: "技能需求", items: ["精通 C++ 與 Python，熟悉 Linux 開發環境", "具備 ROS2 開發經驗（節點、Topic、Service、Action 等通訊機制）", "具備 SLAM（Cartographer、RTAB-Map、ORB-SLAM 等）或視覺/光達定位經驗", "熟悉機器人運動學、路徑規劃演算法（Nav2、A*、RRT）", "了解感測器原理與資料處理（LiDAR 點雲、深度影像、IMU 融合）", "熟悉 git 版本控制，具備除錯與系統排障能力", "具備良好團隊合作精神與溝通能力"] },
            { heading: "加分條件", items: ["參加過 Nexuni 軟體開發實習生計畫", "具有自主移動機器人（AMR）或協作機器手臂軟體開發經驗", "具有 NVIDIA Jetson 平台開發經驗", "具有 Gazebo/Isaac Sim 等機器人模擬環境使用經驗", "具有即時系統或嵌入式系統開發經驗", "Docker 使用經驗"] }
          ],
          en: [
            { heading: "Job Description", items: ["Develop and maintain robotic software systems including perception, localization (SLAM), path planning, and real-time motion control", "Design robot system architecture and develop modules based on the ROS2 framework", "Integrate multiple sensors (LiDAR, depth cameras, IMU, encoders) and develop sensor fusion algorithms", "Develop and tune navigation, obstacle avoidance, and path planning modules", "Deploy robotic software on edge computing platforms (e.g., NVIDIA Jetson)", "Collaborate with hardware and AI teams for system integration and field testing"] },
            { heading: "Skill Requirements", items: ["Proficient in C++ and Python with Linux development experience", "ROS2 development experience (nodes, topics, services, actions)", "SLAM experience (Cartographer, RTAB-Map, ORB-SLAM) or visual/LiDAR-based localization", "Familiarity with robot kinematics and path planning algorithms (Nav2, A*, RRT)", "Understanding of sensor principles and data processing (LiDAR point clouds, depth images, IMU fusion)", "Familiar with git version control, debugging, and system troubleshooting", "Strong teamwork and communication skills"] },
            { heading: "Preferred Qualifications", items: ["Participation in Nexuni software internship", "AMR or collaborative robot arm software development experience", "NVIDIA Jetson platform experience", "Robot simulation experience (Gazebo, Isaac Sim)", "Real-time or embedded systems development experience", "Docker experience"] }
          ],
          ja: [
            { heading: "職務内容", items: ["知覚、位置推定（SLAM）、経路計画、リアルタイム運動制御を含むロボットソフトウェアシステムの開発・保守", "ROS2 フレームワークに基づくロボットシステム設計とモジュール開発", "複数センサー（LiDAR、深度カメラ、IMU、エンコーダ）の統合とセンサーフュージョンアルゴリズムの開発", "ナビゲーション、障害物回避、経路計画モジュールの開発・チューニング", "ロボットソフトウェアをエッジコンピューティングプラットフォーム（NVIDIA Jetson）に展開", "ハードウェア・AI チームと協力しシステム統合と現場テストを実施"] },
            { heading: "スキル要件", items: ["C++ と Python に精通、Linux 開発環境での経験", "ROS2 開発経験（ノード、トピック、サービス、アクション）", "SLAM（Cartographer、RTAB-Map、ORB-SLAM）またはビジョン/LiDAR 位置推定経験", "ロボット運動学・経路計画アルゴリズム（Nav2、A*、RRT）に精通", "センサー原理とデータ処理（LiDAR 点群、深度画像、IMU フュージョン）の理解", "git バージョン管理、デバッグ、トラブルシューティング能力", "チームワークとコミュニケーション能力"] },
            { heading: "優遇条件", items: ["Nexuni ソフトウェアインターン参加経験", "自律移動ロボット（AMR）または協働ロボットアームのソフトウェア開発経験", "NVIDIA Jetson プラットフォーム経験", "ロボットシミュレーション（Gazebo、Isaac Sim）経験", "リアルタイムまたは組み込みシステム開発経験", "Docker 使用経験"] }
          ]
        }
      },
      "SE": {
        title: { zh: "AI 軟體工程師", en: "AI Software Engineer", ja: "AI ソフトウェアエンジニア" },
        type: { zh: "全職", en: "Full-time", ja: "フルタイム" },
        location: { zh: "新竹縣竹北市", en: "Zhubei, Hsinchu County", ja: "新竹県竹北市" },
        sections: {
          zh: [
            { heading: "職務說明", items: ["負責 AI 相關專案的技術研發", "搭配機器學習並設計及開發演算法來達成專案目標", "Deploy AI 到邊緣化運算平台", "負責影像串流及處理", "優化 AI 程式性能及辨識速度", "配合 MLOps 框架"] },
            { heading: "技能需求", items: ["熟悉 Python 或 C++ 的程式語法以及程式邏輯", "熟悉 AI Machine Learning 框架 (PyTorch/Tensorflow)", "熟悉影像處理相關 library 如 OpenCV, numpy 等", "有能力除錯程式及軟體環境相關問題", "有快速學習新知的能力及熱忱", "具備良好團隊合作精神", "熟悉 git 版本控制", "有在 Linux 環境上開發經驗", "對 AI 領域及數據處理有一定了解或對這方面有熱忱"] },
            { heading: "加分條件", items: ["參加過 Nexuni 軟體開發實習生計畫", "具有電腦視覺專案開發經驗", "具有 NVIDIA Jetson 平台開發經驗", "有設計 AI 神經網路模型相關經驗", "有 LLM、強化學習、TinyML 相關經驗", "Docker 使用經驗"] }
          ],
          en: [
            { heading: "Job Description", items: ["Technical R&D for AI-related projects", "Design and develop algorithms with machine learning to achieve project goals", "Deploy AI to edge computing platforms", "Video streaming and processing", "Optimize AI program performance and recognition speed", "Collaborate with the MLOps framework"] },
            { heading: "Skill Requirements", items: ["Proficient in Python or C++ programming", "Familiar with AI ML frameworks (PyTorch/TensorFlow)", "Familiar with image processing libraries (OpenCV, numpy)", "Ability to debug software and environment issues", "Quick learner with enthusiasm for new knowledge", "Good team player", "Familiar with git version control", "Development experience in Linux", "Understanding of or passion for AI and data processing"] },
            { heading: "Preferred Qualifications", items: ["Participation in Nexuni software internship", "Computer vision project experience", "NVIDIA Jetson platform experience", "AI neural network model design experience", "LLM, Reinforcement Learning, or TinyML experience", "Docker experience"] }
          ],
          ja: [
            { heading: "職務内容", items: ["AI 関連プロジェクトの技術研究開発", "機械学習を用いたアルゴリズム設計・開発", "AI をエッジコンピューティングプラットフォームに展開", "映像ストリーミングと処理", "AI プログラムの性能と認識速度を最適化", "MLOps フレームワークに対応"] },
            { heading: "スキル要件", items: ["Python または C++ に精通", "AI ML フレームワーク（PyTorch/TensorFlow）に精通", "画像処理ライブラリ（OpenCV、numpy）に精通", "ソフトウェアのデバッグ能力", "新知識の迅速な学習能力と情熱", "チームワーク精神", "git バージョン管理に精通", "Linux 環境での開発経験", "AI・データ処理への理解または情熱"] },
            { heading: "優遇条件", items: ["Nexuni ソフトウェアインターン参加経験", "コンピュータビジョンプロジェクト経験", "NVIDIA Jetson プラットフォーム経験", "AI ニューラルネットワークモデル設計経験", "LLM、強化学習、TinyML の経験", "Docker 使用経験"] }
          ]
        }
      },
      "SD": {
        title: { zh: "事業發展專員", en: "Sales / Business Development", ja: "営業 / 事業開発" },
        type: { zh: "全職", en: "Full-time", ja: "フルタイム" },
        location: { zh: "新竹縣竹北市", en: "Zhubei, Hsinchu County", ja: "新竹県竹北市" },
        sections: {
          zh: [
            { heading: "職務內容", items: ["發掘商業機會（如 AI 軟體, 智慧工廠, 自動化應用等）", "維護客戶關係", "溝通能力強，對科技行業充滿熱情", "有商機發掘或投標經驗者優先"] }
          ],
          en: [
            { heading: "Job Description", items: ["Discover business opportunities (Smart Store, AI Machine, etc.) and tenders", "Maintain customer relationships", "Proficiency in communication and passionate about the technology industry", "Experience in business opportunities or joining tenders is a plus"] }
          ],
          ja: [
            { heading: "職務内容", items: ["ビジネスチャンス（スマートストア、AI 機械等）の発見、入札", "顧客関係の維持", "コミュニケーション能力が高く、技術業界に情熱", "ビジネスチャンスの発見や入札の経験があるとなお良い"] }
          ]
        }
      },
      "HW-robot": {
        title: { zh: "機器人硬體設計工程師", en: "Robot Hardware Design Engineer", ja: "ロボットハードウェア設計エンジニア" },
        type: { zh: "全職", en: "Full-time", ja: "フルタイム" },
        location: { zh: "新竹縣竹北市", en: "Zhubei, Hsinchu County", ja: "新竹県竹北市" },
        sections: {
          zh: [
            { heading: "職務說明", items: ["設計與開發 AI 機器人及自動化設備之機械結構與外殼", "繪製 CAD 及 3D 圖檔，並產出工程圖面", "負責機構零件選料、公差分析及原型製作", "與軟體及 AI 團隊協作，整合感測器、致動器及嵌入式硬體", "評估並導入鈑金、CNC、3D 列印等製程", "參與產品測試、組裝及品質改善", "撰寫 BOM 表及組裝 SOP 文件"] },
            { heading: "技能需求", items: ["精通 SolidWorks 或 AutoCAD 等 3D 機構設計軟體", "熟悉機械機構設計原理", "具鈑金設計及加工製程知識", "有能力獨立進行公差分析與結構強度評估", "具備良好團隊合作及跨部門溝通能力"] },
            { heading: "加分條件", items: ["參加過 Nexuni 硬體設計開發實習生計畫", "具有機器人或自動化設備之機構設計經驗", "具有 CNC 加工及雷射切割實作經驗", "熟悉致動器及感測器整合", "具有 IoT 硬體模組開發經驗", "了解嵌入式系統基礎"] }
          ],
          en: [
            { heading: "Job Description", items: ["Design and develop mechanical structures and enclosures for AI robots", "Create CAD and 3D model files and engineering drawings", "Component material selection, tolerance analysis, and prototyping", "Collaborate with software and AI teams for sensor/actuator/embedded hardware integration", "Evaluate and implement sheet metal, CNC, and 3D printing processes", "Participate in product testing, assembly, and quality improvement", "Prepare BOM lists and assembly SOP documentation"] },
            { heading: "Skill Requirements", items: ["Proficient in SolidWorks or AutoCAD", "Familiar with mechanical design principles", "Sheet metal design and fabrication knowledge", "Independent tolerance analysis and structural strength evaluation", "Good teamwork and cross-departmental communication"] },
            { heading: "Preferred Qualifications", items: ["Participation in Nexuni hardware internship", "Robot or automation mechanism design experience", "CNC machining and laser cutting experience", "Actuator and sensor integration knowledge", "IoT hardware module development experience", "Embedded systems basics (Arduino, Raspberry Pi)"] }
          ],
          ja: [
            { heading: "職務内容", items: ["AI ロボットの機械構造と筐体の設計・開発", "CAD および 3D モデルファイルの作成", "部品の材料選定、公差解析、プロトタイプ製作", "ソフトウェア・AI チームとの協力（センサー・アクチュエータ・組み込みハードウェア統合）", "板金加工、CNC 加工、3D プリンティングプロセスの評価と導入", "製品テスト、組み立て、品質改善に参加", "BOM リストおよび組み立て SOP ドキュメントの作成"] },
            { heading: "スキル要件", items: ["SolidWorks または AutoCAD に精通", "機械設計の原理に精通", "板金設計および加工プロセスの知識", "公差解析および構造強度評価", "チームワークおよび部門間コミュニケーション能力"] },
            { heading: "優遇条件", items: ["Nexuni ハードウェアインターン参加経験", "ロボットまたは自動化機構設計経験", "CNC 加工およびレーザーカット経験", "アクチュエータおよびセンサー統合の知識", "IoT ハードウェアモジュール開発経験", "組み込みシステムの基礎理解"] }
          ]
        }
      },
      "softwareIntern": {
        title: { zh: "軟體開發實習", en: "Software Engineering Internship", ja: "ソフトウェアエンジニアリングインターンシップ" },
        type: { zh: "實習", en: "Internship", ja: "インターンシップ" },
        location: { zh: "新竹縣竹北市（需到辦公室）", en: "Zhubei, Hsinchu (On-site)", ja: "新竹県竹北市（オンサイト勤務）" },
        sections: {
          zh: [
            { heading: "工作內容", items: ["使用 Python 或 C++ 進行程式開發", "協助 AI 相關專案開發", "每週例會進度報告", "每週配合至少兩天，需到辦公室", "薪資優於勞基法，與配合時數有關"] },
            { heading: "徵求條件", items: ["大學在校生或應屆畢業生，科系不拘", "熟悉 Python 或 C++ 的程式語法以及程式邏輯", "有能力除錯程式及軟體環境相關問題", "有快速學習新知的能力及熱忱", "具備良好團隊合作精神", "熟悉 git 版本控制", "有在 Linux 環境上開發經驗", "對 AI 領域及數據處理有一定了解或有熱忱"] },
            { heading: "加分條件", items: ["熟悉 Python 數學計算工具 (numpy, pandas, scipy)", "了解影像處理 (OpenCV, MATLAB)", "熟悉深度學習套件 (PyTorch, TensorFlow)", "AI 專案開發經驗", "Docker 使用經驗"] },
            { heading: "徵選方法", items: ["寄送履歷至 hr@nexuni.com，標題為 nexuni_Software_Engineer_Intern_YOURNAME", "Zoom 線上面試", "寄信通知結果"] }
          ],
          en: [
            { heading: "Job Description", items: ["Develop software using Python or C++", "Assist with AI-related project development", "Weekly progress reports", "At least two days per week, on-site", "Compensation above labor law standards"] },
            { heading: "Requirements", items: ["Current university student or recent graduate, any major", "Proficient in Python or C++ programming", "Ability to debug software and environment issues", "Quick learner with enthusiasm", "Good team player", "Familiar with git version control", "Linux development experience", "Understanding of or passion for AI and data processing"] },
            { heading: "Preferred Qualifications", items: ["Python math/data tools (numpy, pandas, scipy)", "Image processing (OpenCV, MATLAB)", "Deep learning frameworks (PyTorch, TensorFlow)", "AI project experience", "Docker experience"] },
            { heading: "How to Apply", items: ["Email resume to hr@nexuni.com with subject: nexuni_Software_Engineer_Intern_YOURNAME", "Zoom online interview", "Results notification by email"] }
          ],
          ja: [
            { heading: "業務内容", items: ["Python または C++ でのソフトウェア開発", "AI 関連プロジェクトの支援", "週次進捗報告", "週に最低 2 日オンサイト勤務", "労働基準法を上回る給与"] },
            { heading: "応募条件", items: ["大学在学生または新卒者、専攻不問", "Python または C++ に精通", "ソフトウェアデバッグ能力", "迅速な学習能力と情熱", "チームワーク精神", "git バージョン管理に精通", "Linux 開発経験", "AI・データ処理への理解または情熱"] },
            { heading: "優遇条件", items: ["Python 数学ツール（numpy、pandas、scipy）", "画像処理（OpenCV、MATLAB）", "深層学習フレームワーク（PyTorch、TensorFlow）", "AI プロジェクト経験", "Docker 経験"] },
            { heading: "選考方法", items: ["hr@nexuni.com に件名 nexuni_Software_Engineer_Intern_YOURNAME で履歴書を送付", "Zoom オンライン面接", "メールでの結果通知"] }
          ]
        }
      },
      "hardwareIntern": {
        title: { zh: "硬體設計開發實習", en: "Hardware Engineering Internship", ja: "ハードウェアエンジニアリングインターンシップ" },
        type: { zh: "實習", en: "Internship", ja: "インターンシップ" },
        location: { zh: "新竹縣竹北市（需到辦公室）", en: "Zhubei, Hsinchu (On-site)", ja: "新竹県竹北市（オンサイト勤務）" },
        sections: {
          zh: [
            { heading: "工作內容", items: ["畫製 CAD 及 3D 圖檔", "協助生產排程及工程圖修改", "相關機構設計及功能發想", "參與開發 AIoT 模組機構設計、智慧機器人控制平台等硬體", "每週例會進度報告", "每週配合至少兩天，需到辦公室", "薪資優於勞基法"] },
            { heading: "徵求條件", items: ["大學在校生或應屆畢業生，科系不拘", "熟悉 AutoCAD 或 SolidWorks 等製圖軟體", "有能力依需求修改 CAD 圖", "有快速學習新知的能力及熱忱", "具備良好團隊合作精神"] },
            { heading: "加分條件", items: ["CNC 機械加工實際經驗", "雷射切割加工實際經驗", "壓克力加工實際經驗"] },
            { heading: "徵選方法", items: ["寄送履歷及過去圖面至 hr@nexuni.com，標題為 nexuni_Hardware_Engineer_Intern_YOURNAME", "Zoom 線上面試", "寄信通知結果"] }
          ],
          en: [
            { heading: "Job Description", items: ["Create CAD and 3D model files", "Assist with production scheduling and engineering drawing modifications", "Mechanism design and function conceptualization", "Develop hardware: AIoT module design, smart robot control platforms, etc.", "Weekly progress reports", "At least two days per week, on-site", "Compensation above labor law standards"] },
            { heading: "Requirements", items: ["Current university student or recent graduate, any major", "Proficient in AutoCAD or SolidWorks", "Ability to modify CAD drawings as needed", "Quick learner with enthusiasm", "Good team player"] },
            { heading: "Preferred Qualifications", items: ["CNC machining experience", "Laser cutting experience", "Acrylic processing experience"] },
            { heading: "How to Apply", items: ["Email resume and past drawings to hr@nexuni.com with subject: nexuni_Hardware_Engineer_Intern_YOURNAME", "Zoom online interview", "Results notification by email"] }
          ],
          ja: [
            { heading: "業務内容", items: ["CAD および 3D ファイルの作成", "生産スケジューリングとエンジニアリング図面の修正支援", "機構設計と機能コンセプト化", "AIoT モジュール、スマートロボット制御プラットフォームなどの開発", "週次進捗報告", "週に最低 2 日オンサイト勤務", "労働基準法を上回る給与"] },
            { heading: "応募条件", items: ["大学在学生または新卒者、専攻不問", "AutoCAD または SolidWorks に精通", "要件に応じた CAD 修正能力", "迅速な学習能力と情熱", "チームワーク精神"] },
            { heading: "優遇条件", items: ["CNC 加工経験", "レーザーカット経験", "アクリル加工経験"] },
            { heading: "選考方法", items: ["hr@nexuni.com に件名 nexuni_Hardware_Engineer_Intern_YOURNAME で履歴書と過去の図面を送付", "Zoom オンライン面接", "メールでの結果通知"] }
          ]
        }
      }
    };
    return pages[this.state.id] || null;
  }

  render() {
    const lang = this.state.lang;
    const data = this.getPageData();

    if (!data) {
      return (
        <div id="body" className="jobdetail_page">
          <AnnouncementBanner lang={lang} />
          <Navbar lang={lang} updateLangFunc={this.update_lang} />
          <div style={{ padding: '80px 5vw', textAlign: 'center' }}>
            <p>Page not found</p>
          </div>
          <Footer lang={lang} navigate={(route) => this.navigate(route)} />
        </div>
      );
    }

    const backLabel = { zh: "返回職涯頁", en: "Back to Careers", ja: "キャリアページに戻る" };
    const applyLabel = { zh: "投遞履歷", en: "Apply Now", ja: "応募する" };
    const salaryLabel = { zh: "待遇面議", en: "Salary negotiable", ja: "給与は面談時に決定" };
    const locationLabel = { zh: "工作地點", en: "Location", ja: "勤務地" };
    const addressLabel = {
      zh: "新竹縣竹北市環科一路 31 號 6 樓之二（昌益科技園區）",
      en: "6F-2, No. 31, HuanKe 1st Rd, Zhubei, Hsinchu County (Changyi Tech Park)",
      ja: "新竹県竹北市環科一路 31 号 6 階之二（昌益科技園区）"
    };

    const breadcrumbItems = [
      { label: { zh: "職涯", en: "Careers", ja: "キャリア" }, route: '/about/career' },
      { label: data.title }
    ];

    return (
      <div id="body" className="jobdetail_page">
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <Breadcrumb lang={lang} items={breadcrumbItems} />

        <div className="jd_container">
          {/* Header */}
          <div className="jd_header">
            <button className="jd_back" onClick={() => this.navigate('/about/career')}>
              &larr; {backLabel[lang]}
            </button>
            <h1 className="jd_title">{data.title[lang]}</h1>
            <div className="jd_meta">
              <span className="jd_meta_type">{data.type[lang]}</span>
              <span className="jd_meta_loc">{data.location[lang]}</span>
              <span className="jd_meta_salary">{salaryLabel[lang]}</span>
            </div>
          </div>

          {/* Sections */}
          <div className="jd_body">
            {data.sections[lang].map((section, si) => (
              <div key={si} className="jd_section">
                <h2>{section.heading}</h2>
                <ul>
                  {section.items.map((item, ii) => <li key={ii}>{item}</li>)}
                </ul>
              </div>
            ))}

            {/* Location */}
            <div className="jd_section">
              <h2>{locationLabel[lang]}</h2>
              <p className="jd_address">{addressLabel[lang]}</p>
            </div>
          </div>

          {/* Apply CTA */}
          <div className="jd_apply">
            <button className="jd_apply_btn" onClick={() => window.open('https://www.104.com.tw/company/1a2x6bm4zo', '_blank', 'noopener,noreferrer')}>
              {applyLabel[lang]} &rarr;
            </button>
          </div>
        </div>

        <Footer lang={lang} navigate={(route) => this.navigate(route)} />
      </div>
    );
  }
}

export default JobDetailPage;
